import i18n from '@/utils/i18n';
import React from 'react';
import { Button, Typography, YStack } from '@usepepper/sprout-kit-ui';

interface Props {
  onRetry: () => void;
}

export const CustomersTableFullListError: React.FC<Props> = ({ onRetry }) => (
  <YStack alignItems="center" gap="$12" paddingVertical="$16">
    <Typography color="$textSecondary" size="$sm">
      {i18n.t('finance_hub.customers.full_list_error')}
    </Typography>
    <Button alignSelf="center" onPress={onRetry} size="$md" variant="secondary">
      {i18n.t('retry')}
    </Button>
  </YStack>
);
